export class Signup {

	setupSignup(nameInput: HTMLInputElement, emailInput: HTMLInputElement, subscribeButton: HTMLButtonElement, subscribeErrorMessage: HTMLDivElement) {

		subscribeButton.addEventListener("click", () => {

			const subscribeBtnInnerHTMLOriginal = subscribeButton.innerHTML;

			// Disable button to prevent multiple clicks while processing
			subscribeButton.disabled = true;
			subscribeErrorMessage.textContent = "";

			// Clear previous error styles
			nameInput.classList.remove("input-error");
			emailInput.classList.remove("input-error");

			const name = nameInput.value;
			const email = emailInput.value;

			if(!this.isNameValid(name)) {
				// Make name input has error class
				nameInput.classList.add("input-error");
				subscribeErrorMessage.textContent = "Please enter a name.";
				subscribeButton.disabled = false;
				subscribeButton.innerHTML = subscribeBtnInnerHTMLOriginal;
				return;
			}

			if(!this.isEmailValid(email)) {
				// Make email input has error class
				emailInput.classList.add("input-error");
				subscribeErrorMessage.textContent = "Please enter a valid email.";
				subscribeButton.disabled = false;
				subscribeButton.innerHTML = subscribeBtnInnerHTMLOriginal;
				return;
			}

			subscribeButton.innerHTML = "SUBSCRIBING...";
			// Send subscription request
			this.sendSubscriptionEmail(name, email).then((response) => {
				if(response.success) {
					subscribeButton.innerHTML = "SUBSCRIBED!";
					// Clear input fields
					nameInput.value = "";
					emailInput.value = "";
				} else {
					subscribeButton.innerHTML = subscribeBtnInnerHTMLOriginal;
					subscribeErrorMessage.textContent = response.message;
				}
			}).catch((error) => {
				subscribeErrorMessage.textContent = "An error occurred. Please try again later.";
				console.error("Error during subscription:", error);
			}).finally(() => {
				// Re-enable button after 3 seconds and reset text
				setTimeout(() => {
					subscribeButton.disabled = false;
					subscribeButton.innerHTML = subscribeBtnInnerHTMLOriginal;
				}, 3000);
			});
		});
	}

	async sendSubscriptionEmail(name: string, email: string) : Promise<SignupResponse> {
		// Send a POST request to https://signups.cartadisera.com
		// with `name` and `email` in the body

		const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
		const requestUrl = isLocalhost ? "https://signups-worker-staging.llbermingham.workers.dev" : "https://signups.cartadisera.com";

		const response = await fetch(requestUrl, {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({ name, email })
		});

		if (!response.ok) {
			console.warn(`Signup request failed with status ${response.status}: ${response.statusText}`);
			return new SignupResponse(false, `Sorry, we couldn't subscribe you, please try again later.`);
		}

		return new SignupResponse(true, "Successfully subscribed!");
	}

	isEmailValid(email: string): boolean {
		// Simple email validation regex
		const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return re.test(email);
	}

	isNameValid(name: string): boolean {
		return name.trim().length > 0;
	}

}

// Response we got from signups endpoint
class SignupResponse {
	success: boolean;
	message: string;

	constructor(success: boolean, message: string) {
		this.success = success;
		this.message = message;
	}
}